import { Link } from 'react-router-dom'
import FooterLogo from '../assets/images/logo/logo_cn.svg'

export default function Footer() {
  return (
    <div className='w-full'>
      <div className=' border-solid border-t-[1px] items-center justify-center xl:justify-between border-default-border py-20 px-[15px] xl:px-[240px] flex bg-default-white xl:flex-row flex-col'>
        <img className='hidden xl:block' src={FooterLogo} alt='' />
        <p className='text-[16px] text-default-header text-center'>
          Copyright (c) Chungcheongnamdo office of education. All rights reserved.
        </p>
        <Link
          to='http://www.cne.go.kr/sub/info.do?m=0902&s=cne&fpage=as_center&page=0902'
          target='_blank'
          className='text-[16px] text-[#333] flex shrink-0'
        >
          개인정보처리방침
        </Link>
      </div>
    </div>
  )
}
